"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_YouTube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/React.createElement("title", null, "87171DE0-AAC1-4BF7-A786-10F3301813E6"), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E72B22",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD2A22",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3rd-party-icons",
    transform: "translate(-79.000000, -770.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons+Indicators-/-3rd-Party-Icons-/-YouTube-/-App-Launcher",
    transform: "translate(79.000000, 770.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "YouTube"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.375,9.86076132e-32 C29,9.86076132e-32 32,3 32,7.625 L32,24.375 C32,29 29,32 24.375,32 L7.625,32 C3,32 0,29 0,24.375 L0,7.625 C0,3 3,2.3017203e-24 7.625,2.3017203e-24 L24.375,9.86076132e-32 Z",
    id: "App-Icon-Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.375,0.25 L7.625,0.25 C5.38831967,0.25 3.54069988,0.96910351 2.2549017,2.2549017 C0.96910351,3.54069988 0.25,5.38831967 0.25,7.625 L0.25,24.375 C0.25,26.6116803 0.96910351,28.4593001 2.2549017,29.7450983 C3.54069988,31.0308965 5.38831967,31.75 7.625,31.75 L24.375,31.75 C26.6116803,31.75 28.4593001,31.0308965 29.7450983,29.7450983 C31.0308965,28.4593001 31.75,26.6116803 31.75,24.375 L31.75,7.625 C31.75,5.38831967 31.0308965,3.54069988 29.7450983,2.2549017 C28.4593001,0.96910351 26.6116803,0.25 24.375,0.25 Z",
    id: "Border",
    stroke: "#CCCCCC",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(4.000000, 7.466667)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shadow",
    fill: "#E9E9E9",
    points: "9.6 5.06666667 16.2555663 9.61120722 16.9787152 7.3062737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5510046,0.274229629 C20.5550321,0.274630461 22.63704,0.346998521 23.4508461,1.90233656 C23.4508461,1.90233656 24.2646522,3.03088712 24.2646522,8.53333333 C24.2646522,8.53333333 24.3136731,11.939752 23.9280798,13.7507368 C23.5424288,15.5616641 22.6909054,16.0905607 22.6909054,16.0905607 C22.6909054,16.0905607 22.1446386,16.6193998 20.939645,16.7636182 C19.7735222,16.9032401 16.0767138,17.0564384 12.4743637,17.0661768 L11.8881392,17.0660552 C10.6901592,17.0614144 5.06854602,17.0217812 3.02789507,16.685325 C0.738384239,16.307895 0.416748886,14.1751657 0.416748886,14.1751657 C0.416748886,14.1751657 -0.520936107,8.77632434 0.416748886,2.8975412 C0.416748886,2.8975412 0.688152144,0.549318448 3.42375396,0.274630461 C3.42375396,0.274630461 6.26000338,0.0120701783 11.7370181,0.000400832388 L12.1145407,0 C17.7114329,0 20.4328181,0.262560283 20.5510046,0.274229629 Z M9.6,5.06666667 L9.6,11.7333333 L16.2666667,8.4 L9.6,5.06666667 Z",
    id: "Play-Button",
    fill: "url(#linearGradient-1)"
  })))))));
}

var _default = ic_YouTube;
exports.default = _default;